module.exports = __webpack_public_path__ + "img/Brian K Roberts.cf0bd9ac.png";